(function () {
  // ----------------------------------------------------------------------------
  // FABRIC-DEBUG: temporary diagnostics. Set DEBUG = false (or remove the log
  // calls) once the alt-text filter is confirmed working. Open the browser
  // DevTools Console and look for [FABRIC-DEBUG] lines.
  // ----------------------------------------------------------------------------
  var DEBUG = true;
  var log = function () {
    if (!DEBUG || !window.console || !console.log) return;
    var args = ['%c[FABRIC-DEBUG]', 'color:#b8860b;font-weight:bold'];
    console.log.apply(console, args.concat(Array.prototype.slice.call(arguments)));
  };

  var HIDDEN_CLASS = 'fabric-filter-hidden';

  // Normalize: lowercase + strip every non-alphanumeric char.
  var norm = function (s) { return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };

  // Extract #tags from alt text, drop the leading '#', normalize, drop empties.
  var tagsFromAlt = function (alt) {
    return ((alt || '').match(/#[^\s#]+/g) || []).map(function (t) { return norm(t.slice(1)); }).filter(Boolean);
  };

  // Read the value of a [data-option-name] field, mirroring product-gallery-summary.js.
  var readValue = function (field) {
    var select = field.querySelector('select');
    if (select) {
      // Prefer the clean <option value> (always the raw fabric name) over the
      // option's TEXT, which Dawn renders as "<value> - Unavailable" for a
      // sold-out selection — that suffix would break the hashtag match.
      var opt = select.options[select.selectedIndex];
      return (select.value || (opt && opt.text) || '').trim();
    }
    var sv = field.querySelector('[data-selected-value]');
    return sv ? sv.textContent.trim() : '';
  };

  // Find the variant-selects associated with this gallery. Prefer the nearest
  // ancestor that contains one (the product info container / <product-info>
  // wrapper), then fall back to the document.
  var findVariantSelects = function (gallery) {
    var node = gallery.parentElement;
    while (node) {
      var found = node.querySelector('variant-selects');
      if (found) return found;
      node = node.parentElement;
    }
    return document.querySelector('variant-selects');
  };

  // Warm an image so it fetches + decodes immediately at high priority, rather
  // than lazily after it is revealed. Lazy images inside a display:none subtree
  // are never fetched until shown, so the just-revealed spotlight would
  // otherwise load in lockstep with the whole thumbnail batch.
  var warmImage = function (img) {
    if (!img) return;
    img.setAttribute('fetchpriority', 'high');
    if (img.loading === 'lazy') img.loading = 'eager';
    if (typeof img.decode === 'function') {
      try { img.decode().catch(function () {}); } catch (e) { /* node may be replaced/aborted */ }
    }
  };

  var cssEscape = function (s) {
    return (window.CSS && CSS.escape) ? CSS.escape(s) : s;
  };

  var runGallery = function (gallery) {
    var sectionId = gallery.id.replace('MediaGallery-', '');
    var optionName = gallery.dataset.fabricOptionName || 'Fabric';
    log('runGallery', gallery.id, '| optionName =', JSON.stringify(optionName));

    // Read the currently selected fabric value.
    var selectedKey = '';
    var variantSelects = findVariantSelects(gallery);
    if (!variantSelects) {
      log('  ⚠ no <variant-selects> found near this gallery');
    } else {
      var presentNames = Array.prototype.map.call(
        variantSelects.querySelectorAll('[data-option-name]'),
        function (f) { return f.getAttribute('data-option-name'); }
      );
      log('  option names present in variant-selects:', JSON.stringify(presentNames));
      var field = variantSelects.querySelector('[data-option-name="' + cssEscape(optionName) + '"]');
      if (!field) {
        log('  ⚠ no field matched data-option-name="' + optionName + '". Check the "Fabric option name" setting matches one of the names above (case-sensitive).');
      } else {
        var raw = readValue(field);
        selectedKey = norm(raw);
        log('  matched field. raw selected value =', JSON.stringify(raw), '| normalized selectedKey =', JSON.stringify(selectedKey));
      }
    }

    // Collect every filterable item across slides, thumbnails, and the modal.
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item[data-media-alt]'));
    var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item[data-media-alt]'));
    var modalItems = Array.prototype.slice.call(
      document.querySelectorAll('#ProductModal-' + cssEscape(sectionId) + ' [data-media-alt]')
    );
    var items = slides.concat(thumbnails, modalItems);
    log('  items with [data-media-alt]: slides=' + slides.length, 'thumbnails=' + thumbnails.length, 'modal=' + modalItems.length);

    var imageItems = items.filter(function (it) { return it.dataset.mediaType === 'image'; });
    log('  image items =', imageItems.length, '| sample alt/tags:',
      imageItems.slice(0, 8).map(function (it) { return { alt: it.dataset.mediaAlt, tags: tagsFromAlt(it.dataset.mediaAlt) }; }));

    // Compute desired visibility per item.
    var isVisible = function (item) {
      // Videos / 3D models are exempt — always visible.
      if (item.dataset.mediaType !== 'image') return true;
      // No fabric selected → no filtering.
      if (!selectedKey) return true;
      return tagsFromAlt(item.dataset.mediaAlt).indexOf(selectedKey) !== -1;
    };

    var visibilities = items.map(isVisible);

    // Never-empty guard: if a fabric is selected but no IMAGE item would be
    // visible, force all image items visible.
    var guardTriggered = false;
    if (selectedKey) {
      var anyImageVisible = items.some(function (item, i) {
        return item.dataset.mediaType === 'image' && visibilities[i];
      });
      if (!anyImageVisible) {
        guardTriggered = true;
        visibilities = items.map(function (item) {
          return item.dataset.mediaType === 'image' ? true : isVisible(item);
        });
      }
    }

    // Apply by toggling the hidden class.
    items.forEach(function (item, i) {
      item.classList.toggle(HIDDEN_CLASS, !visibilities[i]);
    });

    var hiddenCount = visibilities.filter(function (v) { return !v; }).length;
    log('  result: hiding', hiddenCount, 'of', items.length, 'items.',
      'selectedKey ' + (selectedKey ? 'set' : 'EMPTY → no filtering'),
      '| never-empty guard ' + (guardTriggered ? 'TRIGGERED (no image matched → showing all)' : 'not triggered'));

    // Re-sync the viewer to the first visible main slide and warm its image so
    // the spotlight paints immediately instead of lazy-loading after the swap.
    var firstVisibleSlide = gallery.querySelector('.product__media-item[data-media-id]:not(.' + HIDDEN_CLASS + ')');
    if (firstVisibleSlide) {
      if (firstVisibleSlide.dataset.mediaType === 'image') {
        warmImage(firstVisibleSlide.querySelector('.product__media img'));
        var thumb = gallery.querySelector(
          '.thumbnail-list__item[data-target="' + cssEscape(firstVisibleSlide.dataset.mediaId) + '"] img'
        );
        warmImage(thumb);
      }
      if (!firstVisibleSlide.classList.contains('is-active') && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(firstVisibleSlide.dataset.mediaId, false);
      }
    }

    // Recompute the slider paging/counter from the now-visible slides.
    // SliderComponent does NOT listen to window 'resize' — call resetPages()
    // directly (it re-runs initPages, filtering by clientWidth>0, and only
    // READS scrollLeft, so it won't jump the slider).
    gallery.querySelectorAll('slider-component').forEach(function (sc) {
      if (typeof sc.resetPages === 'function') sc.resetPages();
    });
  };

  // Re-query the live DOM every run so we always target the current gallery —
  // this also covers theme-editor section reloads that replace the element.
  var runAllGalleries = function () {
    var galleries = document.querySelectorAll('media-gallery[data-fabric-filter="true"]');
    log('runAllGalleries:', galleries.length, 'flagged gallery(ies)');
    galleries.forEach(runGallery);
  };

  if (DEBUG) {
    var allGalleries = document.querySelectorAll('media-gallery');
    log('init. <media-gallery> total =', allGalleries.length);
    Array.prototype.forEach.call(allGalleries, function (g, i) {
      log('  media-gallery[' + i + '] id=' + g.id,
        '| data-fabric-debug=' + JSON.stringify(g.getAttribute('data-fabric-debug')),
        '| data-fabric-filter=' + JSON.stringify(g.getAttribute('data-fabric-filter')),
        '| data-fabric-option-name=' + JSON.stringify(g.getAttribute('data-fabric-option-name')));
    });
  }

  // Run once on init.
  if (document.readyState !== 'loading') {
    runAllGalleries();
  } else {
    document.addEventListener('DOMContentLoaded', runAllGalleries);
  }

  // Bind event handlers ONCE per page (guard against the script being
  // re-injected by a theme-editor section reload).
  if (!window.__fabricAltGalleryBound) {
    window.__fabricAltGalleryBound = true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // optionValueSelectionChange fires on selection (before the section
      // re-render round-trips) — defer a frame for snappy, best-effort filtering.
      if (PUB_SUB_EVENTS.optionValueSelectionChange) {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
          requestAnimationFrame(runAllGalleries);
        });
      }
      // variantChange fires AFTER product-info.js re-renders the section
      // (reconciles the gallery <ul>, sets the variant's featured media active,
      // and REPLACES the modal innerHTML with a fresh UNFILTERED server copy).
      // Run SYNCHRONOUSLY here — publish() is synchronous and variantChange is
      // the last statement of handleUpdateProductInfo, so this re-hides the
      // unfiltered media and re-picks the correct spotlight in the same task,
      // BEFORE the browser paints. No unfiltered flash, no spotlight jump.
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, runAllGalleries);
      }
      log('subscribed to variant change events.');
    } else {
      log('⚠ subscribe/PUB_SUB_EVENTS unavailable — will not re-filter on variant change.');
    }

    // Theme editor: re-render of the section dispatches shopify:section:load;
    // re-run against the freshly injected DOM so the merchant doesn't need a
    // full page reload after toggling settings.
    document.addEventListener('shopify:section:load', function () {
      requestAnimationFrame(runAllGalleries);
    });
  }
})();
